<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkbtnedit  maintable="STKMA" item="W01" valueExpr="MA001" displayExpr="MA002" 
 label="股票代號" #MM003Com  id="MM003"  [(value)]="item.MM003" [required]="true"  placeholder="股票代號"  [readonly]="isBrowse"  (valueChange)="srv.MM003Change(item)"     >
    </app-jkbtnedit>
    <app-jkdatefield  label="更新日期" #MM004Com  id="MM004"  [(value)]="item.MM004" [required]="true"  placeholder="更新日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jktext  label="更新時間" [value]="item.MM005"     >
    </app-jktext>
    <app-jkcheckboxYN  label="選擇" #MM006Com  id="MM006"  [(valueYN)]="item.MM006"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="說明" #MM007Com  id="MM007"  [(value)]="item.MM007" placeholder="說明"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>